import React, { useState, useEffect } from "react";
import TopNav from "../layouts/TopNav";
import { Outlet, useNavigate } from "react-router-dom";
import "../Styles/Setting.css";
import "../Styles/approve.css";
import { BsSearch } from "react-icons/bs";
import { toast, ToastContainer } from "react-toastify";
import TablePagination from "@mui/material/TablePagination";
import ReLoginModal from "../components/ReLoginModal";
import { CircularProgress } from "@mui/material";
import api from "../util/axios";

type Requisition = {
  items: any;
  requisitionRef: string;
  status: string;
  customer: any;
  createdAt: string;
  quantity: String;
};

const Approval = () => {
  const navigate = useNavigate();
  const [getRequisition, setGetRequisition] = useState<Requisition[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [page, setPage] = useState(0);
  const [fullName, setFullName] = useState("");
  const [reLogin, setReLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const token = window.localStorage.getItem("token");

  useEffect(() => {
    const userDataString = window.localStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      const fullName = `${userData.firstName} ${userData.lastName}`;
      setFullName(fullName);
    }
  }, []);

  function queryRequisition(
    pageNumber: number,
    pageSize: number,
    startDate: string,
    endDate: string
  ) {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    setIsLoading(true);

    const queryParams = `?limit=${pageSize}&startDate=${startDate}&endDate=${endDate}&page=${pageNumber}`;

    return api
      .get(`/requisition`, {
        headers: headers,
      })
      .then((res) => {
        setGetRequisition(res.data.data.requisitions);
        console.log("requi", res.data.data.requisitions);
        setIsLoading(false);
      })
      .catch((error) => {
        if (
          error.response.data.message === "jwt expired" ||
          error.response.data.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        toast.error(error.response.data.message);
        setIsLoading(false);
      });
  }
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  const formattedDate = `${year}-${month}-${day}`;
  useEffect(() => {
    const startDate = "2023-01-07";
    const endDate = formattedDate;
    queryRequisition(page + 1, rowsPerPage, startDate, endDate);
  }, [page, rowsPerPage]);

  const [requisitionDetais, setRequisitionDetails] = useState({});

  const [searchQuery, setSearchQuery] = useState("");


  const [selectedCategory, setSelectedCategory] = useState("");


  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className="board">
      <TopNav title="Approval" />
      {reLogin ? <ReLoginModal /> : null}
      <ToastContainer />
      <div className="approveContent">
        {isLoading ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <CircularProgress />
            <h2>Please wait while we process the request...</h2>
          </div>
        ) : (
          <>
            <div className="method">
              <div className="apInput">
                <input
                  type="text"
                  value={searchQuery}
                  placeholder="search by name"
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <BsSearch className="apIcon" />
              </div>
              <div className="filterBy">
                <p>FilterBy Status</p>
                <select
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                >
                  <option value="">Status</option>
                  <option value="AWAITING">Awaiting</option>
                  <option value="APPROVED">Approved</option>
                  <option value="REJECTED">Rejected</option>
                </select>
              </div>
            </div>
            <div className="requiTable">
              {getRequisition
                ?.filter(
                  (requisitions) =>
                    requisitions?.customer?.businessName
                      .toLowerCase()
                      .includes(searchQuery.toLowerCase()) &&
                    (selectedCategory === "" ||
                      requisitions?.status === selectedCategory)
                )
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((requisitions, inx) => {
                  const createdAtDate = new Date(requisitions?.createdAt);

                  const formattedDate = createdAtDate.toLocaleDateString("en-US");
                  const formattedTime = createdAtDate.toLocaleTimeString("en-US", {
                    hour: "numeric",
                    minute: "numeric",
                  });
                  return (
                    <div
                      onClick={() => {
                        setRequisitionDetails(requisitions);
                        navigate("/dashboard/accept", { state: requisitions });
                      }}
                      key={inx}
                      className="requVal p-2"
                    >
                      <div className="RequiName">
                        <h2>{inx + 1}</h2>
                        <div className="reName">
                          <p>{requisitions?.customer?.businessName}</p>
                          <span>Lagos Nigeria</span>
                          <h1 className="fN">Created by: {fullName}</h1>
                        </div>
                      </div>

                      <div className="RequiNum">
                        <p>Requisition Number: {requisitions?.requisitionRef}</p>
                        <p>
                          Requisition Status: {requisitions?.status}
                         
                        </p>
                        <p>Product: {requisitions?.items[0]?.name.toUpperCase()}</p>
                        <p className="flex justify-between">
                          Quantity: {requisitions?.items[0]?.quantity}
                           <div
                            className={`circle ${requisitions.status === "APPROVED"
                              ? "green"
                              : requisitions.status === "AWAITING"
                                ? "orange"
                                : "red"
                              }`}
                          />
                        </p>
                        <p>
                          Amount paid: {requisitions?.items[0]?.totalCost}
                        </p>
                        <h1 className="fN">
                          Created data: {formattedDate} {formattedTime}
                        </h1>
                      </div>
                    </div>
                  );
                })}
            </div>
          </>
        )}
      </div>
      <TablePagination
        rowsPerPageOptions={[15, 25, 50]}
        component="div"
        count={getRequisition.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <Outlet />
    </div>
  );
};

export default Approval;
